import React from 'react'
import './about.less'
import HeroImg from '../../../images/Hero-About.jpg'
import { Link } from 'gatsby'

export default ()=>{
    return(
        <section className="home-about">
            <article>
                <div className="content-container anim-one" data-delay="0s">
                    <img src={HeroImg} alt=""/>
                    <div className="content anim-two" data-delay="0s">
                        <div className="anim-two" data-delay="0.25s">
                            <h2>about empower</h2>
                            <div className="underline"></div>
                        </div>

                        <p className="anim-two" data-delay="0.5s">In a time where the world is in distress we can easily find families that are in need. The Empower Initiative is a cause dedicated to support families who are in need and to provide sustainable methods for progress with the support of the immediate community. </p>

                        <p className="anim-two" data-delay="0.5s">This invites people to help those around them who are in need because we believe that a small act of kindness can go a long way. </p>


                        <a data-delay="0.5s" href="" className="btn anim-two"><Link to="/about">Read More</Link></a>
                    </div>
                </div>
            </article>
        </section>
    )
}